import { Ti18nKeys } from "../../constants/i18n";

export const FIELD_GRID_FALLBACK_LABEL_KEY: Ti18nKeys = "NO_RESULT";
export const FIELD_GRID_LABEL_FONT_SIZE = 12;
export const FIELD_GRID_VALUE_FONT_SIZE = 15;
export const FIELD_GRID_COLUMN_GAP = 30;
export const FIELD_GRID_ROW_GAP = 18;
export const FIELD_GRID_CELL_HEIGHT = 44;
export const FIELD_GRID_EMPTY_VALUE = "—";

export const FIELD_GRID_BLANK_VALUES = [
  "null",
  "Null",
  "NULL",
  "undefined",
  "0000-00-00 00:00:00",
  "0000-00-00"
];
export const FIELD_GRID_MACHINE_FONT_SIZE = 13;
export const FIELD_GRID_MONO_FONT_STACK =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace';
